import { type PayloadAction, createSlice } from "@reduxjs/toolkit"
import { getTgUserId } from "@/helpers/tgWebApp"
import { readState } from "@/store/slices/devTools/slice"
import { resolveIsTMA } from "./helpers"
import { type IAppSliceState } from "./types"

export const initialState: IAppSliceState = {
  language: "en",
  isLoaded: false,
  isDesktop: true,
  isPhoneDevice: false,
  isTMA: resolveIsTMA(readState().tmaOverride, getTgUserId() !== undefined),
  reAuthState: { kind: "idle" },
  screen: {
    width: 0,
    height: 0
  },
  isDev: ["local", "development"].includes(import.meta.env.VITE_NODE_ENV)
}

export const AppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLanguage: (
      state,
      { payload }: PayloadAction<IAppSliceState["language"]>
    ) => {
      state.language = payload
    },
    setIsLoaded: (
      state,
      { payload }: PayloadAction<IAppSliceState["isLoaded"]>
    ) => {
      state.isLoaded = payload
    },
    setIsDesktop: (
      state,
      { payload }: PayloadAction<IAppSliceState["isDesktop"]>
    ) => {
      state.isDesktop = payload
    },
    setIsPhoneDevice: (
      state,
      { payload }: PayloadAction<IAppSliceState["isPhoneDevice"]>
    ) => {
      state.isPhoneDevice = payload
    },
    setScreen: (
      state,
      { payload }: PayloadAction<IAppSliceState["screen"]>
    ) => {
      state.screen = payload
    },
    setReAuthState: (
      state,
      { payload }: PayloadAction<IAppSliceState["reAuthState"]>
    ) => {
      state.reAuthState = payload
    },
    setIsTMA: (state, { payload }: PayloadAction<IAppSliceState["isTMA"]>) => {
      state.isTMA = payload
    }
  }
})

export const {
  setLanguage,
  setIsLoaded,
  setIsDesktop,
  setIsPhoneDevice,
  setScreen,
  setReAuthState,
  setIsTMA
} = AppSlice.actions
